import { render, staticRenderFns } from "./other-activity.vue?vue&type=template&id=30e58c53&scoped=true&"
import script from "./other-activity.vue?vue&type=script&lang=js&"
export * from "./other-activity.vue?vue&type=script&lang=js&"
import style0 from "./other-activity.vue?vue&type=style&index=0&id=30e58c53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e58c53",
  null
  
)

export default component.exports